import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';


@Injectable({
    providedIn: 'root'
})
export class InquiryService {

    constructor(private http: HttpClient) { }

    public callbackPayment(data: any): Observable<any> {
        return this.http.post(environment.apiUrl+"kredivo/callback-payment", data);
    }
    
    public notifPayment(data: any):Observable<any> {
        return this.http.post(environment.apiUrl+"kredivo/payment-notif",data);
    }

    public getOrderId(id: any):Observable<any>{
        return this.http.get(environment.apiUrl+"kredivo/generate-order/"+id);
    }

    public validateUri(refNo: any):Observable<any>{
        return this.http.get(environment.apiUrl+"kredivo/validate-payment/"+refNo);
    }
}